let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("elAhF")).then(() => parcelRequire('87Zqd'));